module.exports = __webpack_public_path__ + "img/ecology.18f83449.png";